import { EventContent } from "../models/conversation.model";

export function mapEventContentToMessage (data: EventContent): string {
  const who = data.event.participants.map(p => p.name).join(', ');
  return `${data.event.type}: ${who}`;
}